
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecocredits-monthly-madness",
      function () {
        return require("private-next-pages/ecocredits-monthly-madness/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecocredits-monthly-madness"])
      });
    }
  